var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multipane',{staticClass:"custom-resizer"},[_c('NavigationList',{staticClass:"listWrapper",style:(_vm.style)}),_vm._v(" "),_c('multipane-resizer'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b73cd12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/navigation/Index.vue
// module id = null
// module chunks = 